module.exports = "/images/vendor/flag-icon-css/flags/4x3/pr.svg?0811a0517cf38bb44f513ab15b7532de";